
let _bilibili = {

    //加载基础代码
    load: function(){
        var script = document.createElement('script');
        script.type = 'text/javascript';
        script.async = true;
        script.src = 'https://s1.hdslb.com/bfs/cm/cm-sdk/static/js/track-collect.js';

        let _head = document.getElementsByTagName("head")[0];
        _head.appendChild(script);
    },

    //加载事件代码
    submit: function () {
        try {
            window.bilicm.mbase.report_data()
        } catch (e) {
            console.log(e)
        }
    },
};

export default _bilibili
